<template>
  <div class="_component-trigger" :class="componentClass" @click="$emit('input', !value)">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'Trigger',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    componentClass() {
      let ret = {};
      ret['active'] = !!this.value;
      return ret;
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
